import {
  dcaLifecycleStatus,
  type DcaLifecycleFields,
} from './lifecycle-status';
import { LifecycleStatusTag } from './lifecycle-status-tag';

/**
 * The lifecycle tag for a DCA decline (Promoted, Draft or Archived), or nothing when the status
 * is unknown. Declines have no Default. See dcaLifecycleStatus.
 *
 * @param {DcaLifecycleFields & {className?: string}} props - The decline's fields.
 * @return {JSX.Element | null} The tag.
 */
export function DcaStatusTag({
  className,
  ...fields
}: DcaLifecycleFields & { className?: string }) {
  const status = dcaLifecycleStatus(fields);
  return status ? (
    <LifecycleStatusTag status={status} subject="dca" className={className} />
  ) : null;
}
